import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import RelcoreDocumentTitle from '../components/RelcoreDocumentTitle';

const NotFound = () => (
  <RelcoreDocumentTitle title='Not Found'>
    <Box mt={3}>
      <Grid container justifyContent='center' alignItems='center'>
        <Grid item sm={6}>
          <Paper>
            <Box p={4} style={{ textAlign: 'center' }}>
              <Typography variant='h3'>
                The page requested does not exist
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  </RelcoreDocumentTitle>
);

export default NotFound;
